function formatPrice(value) {
  const valueFormatted = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
  });
  return valueFormatted.format(value);
}

export default formatPrice;